import { render, staticRenderFns } from "./ClickAndDrag.vue?vue&type=template&id=6c457750&scoped=true&"
import script from "./ClickAndDrag.vue?vue&type=script&lang=ts&"
export * from "./ClickAndDrag.vue?vue&type=script&lang=ts&"
import style0 from "./ClickAndDrag.vue?vue&type=style&index=0&id=6c457750&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c457750",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VIcon})
